import { firstBy } from "thenby";
import { HisRule, SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { HisBasic } from "./HisBasic";
import { HisRow, SpwkHisStep } from "./HisRow";
import { ToDistinctArray } from "./HisRowParser_既往病史_自覺症狀";
import { SpwkMetaData, SpwkMetaData_DataType } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";

export class HisRowParser_作業經歷 {

  static ConvertToHisRowList(step: SpwkHisStep, func_code: string, his_basic: HisBasic, meta_table: SpwkMetaTable): HisRow[] {
    if (step.Chapter !== SpwkUtilV3.CHAPTER_作業經歷) {
      throw new Error("必須是 作業經歷 !!!");
    }

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_作業經歷);


    let row_list: HisRow[] = [];

    for (const q_meta of q_meta_list) {
      if (q_meta.q_his_rule === HisRule.CH2_B02) {

        let data_row = CH2_B02_解碼(q_meta, step, meta_table, his_basic);
        row_list.push(data_row);

      } else if (q_meta.q_his_rule === HisRule.CH2_B02_52) {

        let data_row = CH2_B02_52_解碼(q_meta, step, meta_table, his_basic);
        if (data_row != null) {
          row_list.push(data_row);
        }

      }
      else if (q_meta.func_code === "B01") {
        if (q_meta.his_code === "4") {
          let data_row = CH2_B01_解碼(q_meta, step, meta_table, his_basic);
          row_list.push(data_row);
        }
      }
      else if (q_meta.q_his_rule === HisRule.None) {// 無處理規則，跳過
        //throw new_ErrorAlert("416841 作業經歷: 未知的規則 None !!!\ndata_guid: " + q_meta.data_guid + "\n" + q_meta.code);
        continue;// pass; 

      } else if (q_meta.IsHisBasicMeta()) {// 基本檔規則，已經在 基本檔.xls 處理過了
        continue;// pass; 

      } else {
        throw new_ErrorAlert("416841 作業經歷: 未知的規則 [" + q_meta.q_his_rule + "] !!!\ndata_guid: " + q_meta.data_guid + "\n" + q_meta.code);
      }
    }

    return row_list;


  }


}

function CH2_B02_解碼(q_meta: SpwkMetaData, step: SpwkHisStep, meta_table: SpwkMetaTable, his_basic: HisBasic): HisRow {

  if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {
    const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);
    data_row.項目 = q_meta.his_code;

    let rslt = meta_table.GetRadioOption_HisCodeBundle(q_meta);

    if (rslt.opt_meta != null) {// 如果有填選項
      data_row.結果 = rslt.his_code;
      let input_meta_list = meta_table.FilterInputs_ByOptionGuid(rslt.opt_meta.data_guid);
      if (input_meta_list.length === 1) {
        data_row.備註 = input_meta_list[0].rhf_value ?? "";
      } else if (input_meta_list.length > 1) {
        throw new_ErrorAlert("465843 目前 B02 的解碼 只能有1個 Input !!!");
      } else {
        // pass 沒有題目就不用處理
      }
    }

    return data_row;

  } else if (q_meta.kind === SpwkUtilV3.Q_KIND_多選) {
    const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);
    data_row.項目 = q_meta.his_code;

    let rslt = meta_table.GetCheckOption_HisCodeAndMetaList_Bundle(q_meta);

    const 結果 = ToDistinctArray(rslt.his_code_list).join(',');
    data_row.結果 = 結果;

    return data_row;

  } else {
    throw new_ErrorAlert("616468 作業經歷.CH2_B02_解碼: 只能是 單選 或 多選 !!!\ndata_guid: " + q_meta.data_guid);
  }



}


/** */
function CH2_B02_52_解碼(q_meta: SpwkMetaData, step: SpwkHisStep, meta_table: SpwkMetaTable, his_basic: HisBasic): HisRow | null {

  if (q_meta.his_code !== "521") {
    return null;// 遇到 521 一次處理，其他忽略
  }

  const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);
  data_row.項目 = "52";// 52 系列的答案都放在這裡

  let relate_questions = meta_table.meta_rows.filter(
    x => x.chapter === step.Chapter
      && x.data_type === SpwkMetaData_DataType.Question
      && x.q_his_rule === HisRule.CH2_B02_52
  );
  relate_questions = relate_questions.sort(firstBy(x => x.his_code));

  let list = [];
  for (const q_meta of relate_questions) {
    if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {
      let rslt = meta_table.GetRadioOption_HisCodeBundle(q_meta);
      list.push(q_meta.his_code + "#" + rslt.his_code);

    } else if (q_meta.kind === SpwkUtilV3.Q_KIND_多選) {
      let rslt = meta_table.GetCheckOption_HisCodeAndMetaList_Bundle(q_meta);
      let str = "";
      if (rslt.his_code_list.length > 0) {
        str = rslt.his_code_list.join(",");
      }

      list.push(q_meta.his_code + "#" + str);

    } else {
      throw new_ErrorAlert("4684614 題目必須是 單選 或 多選 !!!");
    }

  }

  data_row.結果 = list.join("@");
  if (data_row.結果 === '521#@522#@523#@524#') {
    data_row.結果 = '';
  } else if (data_row.結果 != null) {
    return (data_row);
  } else {
    throw new_ErrorAlert('7164932' + '請確認data_row.結果')
  }
  return data_row;
}

function CH2_B01_解碼(q_meta: SpwkMetaData, step: SpwkHisStep, meta_table: SpwkMetaTable, his_basic: HisBasic): HisRow {
  let rslt = meta_table.GetRadioOption_HisCodeBundle(q_meta);
  const data_row: HisRow = new HisRow(his_basic, step.HIS類別代碼);
  if (rslt.opt_meta != null) {// 如果有填選項
    data_row.項目 = q_meta.his_code;
    data_row.結果 = rslt.his_code;
    let input_meta_list = meta_table.FilterInputs_ByOptionGuid(rslt.opt_meta.data_guid);
    if (input_meta_list.length === 1) {
      data_row.備註 = input_meta_list[0].rhf_value ?? "";
    } else if (input_meta_list.length > 1) {
      throw new_ErrorAlert("4658413 目前 B01 的解碼 只能有1個 Input !!!");
    } else {
      // pass 沒有題目就不用處理
    }
  }
  return data_row
}
